import { SHOP_LOCALES } from 'src/client/components/constants';

export const minLength = {
  zip: {
    [SHOP_LOCALES.NL]: 7,
    [SHOP_LOCALES.BE]: 4,
  },
  dhl: 6,
};

export const maxLength = {
  email: 50,
  dhl: 10,
};
